import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { useIsPatientOrEmployee } from 'stores/user';
import type { Appointment } from 'types/appointments';
import { getPatientName, getStatusBadge } from 'utils/appointments';

interface CardHeaderProps {
  appointment: Appointment;
}

export const CardHeader = ({ appointment }: CardHeaderProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { state } = useLocation();
  const isPatientOrEmployee = useIsPatientOrEmployee();

  const title = isPatientOrEmployee
    ? t('AppointmentCard.heading')
    : t('PsychologistAppointment.session.heading', {
        patientName: getPatientName(state?.appointment?.patient),
        ns: LOCIZE_NS.PSYCHOLOGIST,
      });

  return (
    <div className="flex justify-between max-am-md:flex-col gap-4">
      <h2 className="text-2xl font-semibold text-denim-600">{title}</h2>
      {getStatusBadge(appointment)}
    </div>
  );
};
